import * as React from 'react';
import { Router, Switch, Route } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { syncHistoryWithStore } from 'mobx-react-router';
import Loadable, { DefaultComponent } from '@loadable/component';

import styles from './index.module.scss';

import * as store from '@store/index';
import Provider from '@shared/App/Provider';
import IntlWrapper from '@locales/IntlWrapper';
import PageLoading from '@components/PageLoading';

const browserHistory = createBrowserHistory();
const history = syncHistoryWithStore(browserHistory, store.routerStore);

const AppWrapper = ({ children }: { children?: React.ReactNode }) => (
    <div className={styles.appWrapper}>{children}</div>
);

export function loadComponent<T>(loader: (props: T) => Promise<DefaultComponent<T>>) {
    return Loadable(loader, { fallback: <PageLoading /> });
}

export const asynchronousComponents = {
    Home: loadComponent(() => import(/* webpackChunkname: "home" */ '@views/Home')),
    InsuranceInformation: loadComponent(() =>
        import(/* webpackChunkname: "insurance-information" */ '@views/InsuranceInformation')
    ),
    SuccessfulInsurance: loadComponent(() =>
        import(/* webpackChunkname: "successful-insurance" */ '@views/SuccessfulInsurance')
    ),
    SignaturePage: loadComponent(() => import(/* webpackChunkName: "signature-page" */ '@views/SignaturePage'))
};

// store.recordStore.startRecord();

function App() {
    return (
        <Provider>
            <IntlWrapper>
                <AppWrapper>
                    <Router history={history}>
                        <Switch>
                            <Route exact path="/" component={asynchronousComponents['Home']} />
                            <Route
                                exact
                                path="/insurance-info"
                                component={asynchronousComponents['InsuranceInformation']}
                            />
                            <Route exact path="/signature" component={asynchronousComponents['SignaturePage']} />
                            <Route exact path="/success" component={asynchronousComponents['SuccessfulInsurance']} />
                        </Switch>
                    </Router>
                </AppWrapper>
            </IntlWrapper>
        </Provider>
    );
}

export default App;
